import { Link } from 'react-router-dom';
import { EmptyState, PageHeader } from '../components/ui';

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="404" subtitle="Nie znaleziono strony." />
      <EmptyState icon="?" title="Ta sekcja nie istnieje" hint="Wróć do dashboardu." />
      <div style={{ textAlign: 'center' }}>
        <Link className="btn btn--primary" to="/">
          Dashboard
        </Link>
      </div>
    </>
  );
}
